import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function Button({
  children,
  className = '',
  onClick,
  href
}: ButtonProps) {
  const sharedClassName = `inline-block bg-gold hover:bg-gold-light text-navy font-semibold py-4 px-8 rounded-sm shadow-lg transition-colors duration-300 tracking-wide uppercase text-sm md:text-base w-full md:w-auto text-center ${className}`;
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={sharedClassName} data-id="element-146">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={sharedClassName} onClick={onClick} data-id="element-147">
      {children}
    </motion.button>;
}